import Keycloak from 'keycloak-js'

const AUTH_BACKEND = `${
  (window)?._env_?.REACT_APP_AUTH_BACKEND !== undefined
    ? (window)?._env_?.REACT_APP_AUTH_BACKEND
    : process.env.REACT_APP_AUTH_BACKEND
}`

const keycloakConfig = {
  url: `https://${AUTH_BACKEND}/auth`,
  realm: 'client',
  clientId: 'portal-public',
}

const keycloak = new Keycloak(keycloakConfig)

export default keycloak
